import { AgGridReact } from 'ag-grid-react'
import { useRef, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import 'ag-grid-enterprise'

import { getLocaleText } from '../../../actions/datagrid'
import { defaultColDef, getRowId, sideBar, statusBar } from '../../../common/grid'
import { TemplateProfileImage } from '../../../common/icons'
import { AddTask } from './taskmodal'

export function DiscussionGroup3({ state, setDiscussion, handleChange, personId }) {
	const { t } = useTranslation()
	const [taskModalShow, setTaskModalShow] = useState(false)

	const [task, setTask] = useState({})

	const taskStatusMap = {
		OPEN: t('Open', 'Avoinna'),
		DONE: t('Done', 'Pidetty'),
		LATE: t('Late', 'Myöhässä'),
	}

	const gridRef = useRef()

	const gridComponents = {
		templateProfileImage: TemplateProfileImage,
	}

	const columnDefs = [
		{
			headerName: t('Status', 'Tila'),
			field: 'status',
			filter: 'agNumberColumnFilter',
			width: 120,
			valueGetter: (params) => taskStatusMap[params.data[params.colDef.field]],
		},
		{
			headerName: t('Created', 'Luotu'),
			field: 'created',
			width: 150,
		},
		{
			headerName: t('Title', 'Otsikko'),
			field: 'title',
			width: 300,
		},
		{
			headerName: t('Description', 'Kuvaus'),
			field: 'description',
			width: 300,
			hide: true,
		},
		{
			headerName: t('Assignees', 'Tekijät'),
			field: 'assignees',
			width: 300,
			valueGetter: (params) =>
				params.data[params.colDef.field] && params.data[params.colDef.field].map((assignees) => assignees.personName),
		},
		{
			headerName: t('DueDate', 'Eräpäivä'),
			field: 'dueDate',
			width: 150,
		},
	]

	const doubleClickAction = (row) => {
		setTask(row.data)
		setTaskModalShow(true)
	}

	return (
		<Accordion defaultActiveKey={['discussiontasks-1']} flush alwaysOpen>
			<Accordion.Item key="discussiontasks-1" eventKey="discussiontasks-1">
				<Accordion.Header>{t('TasksAndGoals', 'Tehtävät & tavoitteet')}</Accordion.Header>
				<Accordion.Body>
					<Row className="my-1 h-200">
						<Col sm="4"></Col>
						<Col sm="8" align="right">
							<Row className="g-2">
								<Col />
								<Col md="auto">
									<AddTask
										show={taskModalShow}
										setShow={setTaskModalShow}
										setDiscussion={setDiscussion}
										state={task}
										setState={setTask}
										handleChange={handleChange}
										discussionPerson={state.personId}
										discussionPersonName={state.personName}
										hideAddButton={!!personId}
									/>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row className="ag-theme-material styles-ag flex-grow-1 h-450">
						<AgGridReact
							ref={gridRef}
							components={gridComponents}
							columnDefs={columnDefs}
							defaultColDef={defaultColDef}
							sideBar={sideBar}
							rowData={state?.tasks}
							statusBar={!personId && statusBar}
							onRowDoubleClicked={doubleClickAction}
							getRowId={getRowId}
							getLocaleText={(params) => getLocaleText(t, params)}
							animateRows
							suppressCellFocus
							enableCellTextSelection
							//onGridReady={({ api }) => api.sizeColumnsToFit()}
							debug={import.meta.env.DEV}
						/>
					</Row>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	)
}
